import React from "react";
import { COMMENT_SAVING_STATUS, COMMENTS_INPUT_MAX_LENGTH, COMMENTS_INPUT_THRESHOLD_LENGTH } from "utils/constants";
import "./draftActionlessComments.scss";
import { DraftCommentsValidationParams } from "types/comments";
import { InlineLoader, InlineLoaderState } from "components/common/InlineLoader.component";

const CommentsValidation: React.FC<DraftCommentsValidationParams> = ({ comment, offline, savingStatus, translate }) => {
    const characterMaxLimitReached = comment?.length > COMMENTS_INPUT_MAX_LENGTH;
    const characterThresholdReached = comment?.length >= COMMENTS_INPUT_THRESHOLD_LENGTH && comment?.length <= COMMENTS_INPUT_MAX_LENGTH;

    const draftInfo = (
        <InlineLoader
            state={InlineLoaderState.Info}
            text={translate("taskDetail.draftComment")}
            tooltip={{
                id: "draftCommentInfoTooltip",
                content: () => translate("taskDetail.draftCommentCanBeSaved")
            }}
        />
    );

    if (!comment) {
        return draftInfo;
    }

    if (offline) {
        return (
            <InlineLoader
                state={InlineLoaderState.Error}
                text={translate("taskDetail.draftCommentNotSaved")}
                tooltip={{
                    id: "commentNotDeliveredTooltip",
                    content: () => translate("taskDetail.commentNotDeliveredTooltip")
                }}
            />
        );
    }

    if (characterMaxLimitReached) {
        return (
            <InlineLoader
                state={InlineLoaderState.Error}
                text={translate("taskDetail.draftCommentsCharacters")}
                tooltip={{
                    id: "commentTooLongTooltip",
                    content: () => translate("taskDetail.commentTooLongTooltip")
                }}
            />
        );
    }

    if (characterThresholdReached) {
        return (
            <InlineLoader
                state={InlineLoaderState.Warning}
                text={translate("taskDetail.draftCommentsCharactersLeft", (comment.length))}
            />
        );
    }

    switch (savingStatus) {
        case COMMENT_SAVING_STATUS.SAVING:
            return <InlineLoader state={InlineLoaderState.Active} text={translate("taskDetail.draftCommentUpdating")} />;
        case COMMENT_SAVING_STATUS.DONE:
            return <InlineLoader state={InlineLoaderState.Completed} text={translate("taskDetail.draftCommentTextUpdated")} />;
        case COMMENT_SAVING_STATUS.ERROR:
            return <InlineLoader state={InlineLoaderState.Error} text={translate("taskDetail.draftCommentError")} />;
        default:
            return draftInfo;
    }
};

export default CommentsValidation;
